import { MAX_SNAPCHAT_TAGS, MAX_SPECTACLES_TAGS } from "../../submit/components/constants";
import { LENS_DESCRIPTION_MAX_CHARS, LENS_RELEASE_NOTE_MAX_CHARS } from "../components/constants";

export const validateAndSanitizeDescription = (description: string | undefined): string => {
    const trimmed = (description ?? "").trim();
    return trimmed.slice(0, Math.max(0, LENS_DESCRIPTION_MAX_CHARS));
};

export const validateAndSanitizeTags = (tags: string[] | undefined): string[] => {
    const cleanTags = (tags ?? [])
        .map((tag) => tag.trim())
        .filter((tag) => tag.length > 0)
        .slice(0, MAX_SNAPCHAT_TAGS);
    return cleanTags;
};

export const validateAndSanitizeSpectaclesTags = (tags: string[] | undefined): string[] => {
    const cleanTags = (tags ?? [])
        .map((tag) => tag.trim())
        .filter((tag) => tag.length > 0)
        .slice(0, MAX_SPECTACLES_TAGS);
    return cleanTags;
};

export const validateAndSanitizeReleaseNote = (releaseNote: string): string => {
    const trimmed = releaseNote.trim();
    return trimmed.slice(0, Math.max(0, LENS_RELEASE_NOTE_MAX_CHARS));
};

export const validateLensId = (lensId: string): void => {
    if (!lensId || lensId.trim().length === 0) {
        throw new Error("Cannot update lens. Missing Lens ID.");
    }
};
